var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166.796,
    height: 40.455,
    viewBox: "0 0 166.796 40.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2675",
    "data-name": "Group 2675",
    transform: "translate(-62.602 -41.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M270.328,266.377l.282-.142-.188-.237a14.36,14.36,0,0,0-9.115-5.833V254.9h-5.591v5.217a15.243,15.243,0,0,0,0,29.879v5.217h5.591v-5.264a13.412,13.412,0,0,0,3.289-1.091l.282-.142-.188-.237a14.174,14.174,0,0,1-2.208-4.932l-.094-.285-.282.142a8.487,8.487,0,0,1-3.524.806c-4.98,0-8.786-3.936-8.786-9.2a8.766,8.766,0,0,1,8.833-9.106,8.192,8.192,0,0,1,6.86,3.557l.188.237.188-.237A13.26,13.26,0,0,1,270.328,266.377Z",
    transform: "translate(-180.898 -213.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M308.263,288.193c-1.41-2.039-4.088-2.893-6.39-2.893-5.121,0-9.773,4.031-9.773,10.481s4.651,10.481,9.773,10.481c2.208,0,4.98-.9,6.39-2.893v2.514h5.591V285.774h-5.591ZM302.954,301a5.178,5.178,0,0,1-5.168-5.217,5.107,5.107,0,0,1,5.168-5.17,5.193,5.193,0,0,1,0,10.387Z",
    transform: "translate(-206.663 -229.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M358.981,285.2a7.889,7.889,0,0,0-6.39,2.94v-2.419H347v25.563h5.591v-7.968c1.41,2.039,4.135,2.893,6.39,2.893,5.121,0,9.773-4.031,9.773-10.481C368.8,289.231,364.1,285.2,358.981,285.2Zm-1.034,15.7a5.193,5.193,0,0,1,0-10.387,5.194,5.194,0,0,1,0,10.387Z",
    transform: "translate(-235.768 -229.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M413.563,288.193c-1.41-2.039-4.088-2.893-6.39-2.893-5.121,0-9.773,4.031-9.773,10.481s4.651,10.481,9.773,10.481c2.208,0,4.98-.9,6.39-2.893v2.514h5.591V285.774h-5.591ZM408.253,301a5.178,5.178,0,0,1-5.168-5.217,5.107,5.107,0,0,1,5.168-5.17,5.193,5.193,0,0,1,0,10.387Z",
    transform: "translate(-262.488 -229.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M464.281,285.2a7.889,7.889,0,0,0-6.39,2.94v-2.419H452.3v25.563h5.591v-7.968c1.41,2.039,4.135,2.893,6.39,2.893,5.121,0,9.773-4.031,9.773-10.481C474.054,289.231,469.4,285.2,464.281,285.2ZM463.2,300.9a5.193,5.193,0,0,1,0-10.387,5.138,5.138,0,0,1,5.121,5.217A5.069,5.069,0,0,1,463.2,300.9Z",
    transform: "translate(-291.593 -229.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M517.96,296.592c0,3.6-2.49,4.7-4.464,4.7-1.926,0-3.806-1.423-3.806-4.553V286.3H504.1V297.35c-.047,6.023,2.678,9.533,7.893,9.533,1.973,0,5.121-1.138,5.967-3.747v3.272h5.591V286.3H517.96Z",
    transform: "translate(-319.055 -230.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 5.591,
    height: 27.318,
    transform: "translate(208.537 48.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M579.48,278.256V271h-5.591v7.256H570.6v4.363h3.289v15.7h5.591v-15.7h4.229v-4.363Z",
    transform: "translate(-354.31 -222.172)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6c5491e88d7a1d1eb5d206ef5ffc34f7.svg";
export { ForwardRef as ReactComponent };